module.exports = __webpack_public_path__ + "static/img/9.3faef24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u_img/9.png
// module id = uwWM
// module chunks = 2